module.exports = __webpack_public_path__ + "img/aboutus-img.d5ddf3ad.jpg";